<template>
    <eqt-table @refresh="refresh" @delete="deleteItem" :total="total" :loading="loading" :title="$t('Pages.RecordBooks.deleted_title')" :subtitle="$t('Common.table_subtitle')" :items="items" :headers="headers" hideShowBtn hideEditBtn>
        <template slot="items" slot-scope="{ item }">
            <td>{{ item.id }}</td>
            <td>
              <p>{{ item.partner.name }}</p>
              <p>{{ $t('Pages.Partners.model.pib') + ': ' + item.partner.pib }}</p>
              <p>{{ item.partner.mbr ? $t('Pages.Partners.model.mbr') + ': ' + item.partner.mbr : null }}</p>
            </td>
            <td>{{ item.documentType.name }}</td>
            <td>{{ item.number }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.document_number ? item.document_number : $t('Common.not_assigned') }}</td>
            <td>{{ item.importTransportType.name }}</td>
            <td>{{ item.exportTransportType.name }}</td>
            <td>{{ item.realLocation.name }}</td>
        </template>
        <template slot="action-items" slot-scope="{ item }">
          <v-tooltip top>
            <v-btn slot="activator" class="mx-0" small flat icon color="tertiary lighten-2" :to="'deleted-record-books/' + item.id + '/show'">
              <v-icon small>mdi-eye-settings</v-icon>
            </v-btn>
            <span>{{$t('Core.Fields.show')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" class="mx-0" small flat icon color="indigo lighten-2" @click="restoreItem(item.id)">
              <v-icon small>mdi-file-restore</v-icon>
            </v-btn>
            <span>{{$t('Core.Fields.restore')}}</span>
          </v-tooltip>
        </template>
    </eqt-table>
</template>

<script>
  import i18n from '@/i18n'
  import EqtTable from '../../components/core/Table'
  export default {
    name: "document-types-table",
    components: {EqtTable},
    props: {
      items: {
        type: Array,
        required: true
      },
      total: {
          type: Number,
          default: 0,
      },
      loading: {
          type: Boolean,
          required: true
      }
    },
    data: () => ({
      headers: [
        {
          sortable: true,
          text: '#',
          value: 'id'
        },
        {
          sortable: true,
          text: i18n.t('Pages.RecordBooks.model.partner'),
          value: 'parner.name'
        },
        {
          sortable: false,
          text: i18n.t('Pages.RecordBooks.model.document_type'),
          value: 'documentType.name'
        },
        {
          sortable: true,
          text: i18n.t('Pages.RecordBooks.model.number'),
          value: 'number'
        },
        {
          sortable: false,
          text: i18n.t('Pages.RecordBooks.model.date'),
          value: 'date'
        },
        {
          sortable: true,
          text: i18n.t('Pages.RecordBooks.model.document_number'),
          value: 'document_number'
        },
        {
          sortable: false,
          text: i18n.t('Pages.RecordBooks.model.import_transport_type'),
          value: 'importTransportType.name'
        },
        {
          sortable: false,
          text: i18n.t('Pages.RecordBooks.model.export_transport_type'),
          value: 'exportTransportType.name'
        },
        {
          sortable: false,
          text: i18n.t('Pages.RecordBooks.model.real_location'),
          value: 'realLocation.name'
        }
      ],
    }),
    methods: {
      refresh(data){
        this.$emit('refresh', data);
      },
      restoreItem(itemId) {
        this.$emit('restore', itemId);
      },
      deleteItem(item){
        this.$emit('delete', item);
      }
    }
  }
</script>

<style scoped>

</style>